__turbopack_context__.v({
  "fallback": "elements-slider-free-module-scss-module__bR_eQW__fallback",
  "root": "elements-slider-free-module-scss-module__bR_eQW__root",
  "slide": "elements-slider-free-module-scss-module__bR_eQW__slide",
});
